import {
  Directive,
  ElementRef,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  Output,
  Renderer2
} from '@angular/core';
import { calculateDragImageOffset, DndDragImageOffsetFunction, DndEvent, setDragData, setDragImage } from './dnd-utils';
import { DndHandleDirective } from './dnd-handle.directive';
import { dndState, endDrag, startDrag } from './dnd-state';
import { EffectAllowed } from './dnd-types';
export class DndDragImageRefDirective {
/**
 * @param {?} parent
 * @param {?} elementRef
 */
constructor( parent:DndDraggableDirective,
               elementRef:ElementRef ) {

    parent.registerDragImage( elementRef );
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: "[dndDragImageRef]"
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: DndDraggableDirective, },
{type: ElementRef, },
];
}

function DndDragImageRefDirective_tsickle_Closure_declarations() {
/** @type {?} */
DndDragImageRefDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DndDragImageRefDirective.ctorParameters;
}

export class DndDraggableDirective {

  
  dndDraggable:any;

  
  dndEffectAllowed:EffectAllowed = "copy";

  
  dndType?:string;

  
  dndDraggingClass = "dndDragging";

  
  dndDraggingSourceClass = "dndDraggingSource";

  
  dndDraggableDisabledClass = "dndDraggableDisabled";

  
  dndDragImageOffsetFunction:DndDragImageOffsetFunction = calculateDragImageOffset;

  
  readonly dndStart:EventEmitter<DragEvent> = new EventEmitter<DragEvent>();

  
  readonly dndEnd:EventEmitter<DragEvent> = new EventEmitter<DragEvent>();

  
  readonly dndMoved:EventEmitter<DragEvent> = new EventEmitter<DragEvent>();

  
  readonly dndCopied:EventEmitter<DragEvent> = new EventEmitter<DragEvent>();

  
  readonly dndLinked:EventEmitter<DragEvent> = new EventEmitter<DragEvent>();

  
  readonly dndCanceled:EventEmitter<DragEvent> = new EventEmitter<DragEvent>();

  
  draggable = true;
private dndHandle?:DndHandleDirective;
private dndDragImageElementRef?:ElementRef;
private dragImage:Element;
/**
 * @param {?} value
 * @return {?}
 */
set dndDisableIf( value:boolean ) {

    this.draggable = !value;

    if( this.draggable ) {

      this.renderer.removeClass( this.elementRef.nativeElement, this.dndDraggableDisabledClass );
    }
    else {

      this.renderer.addClass( this.elementRef.nativeElement, this.dndDraggableDisabledClass );
    }
  }
/**
 * @param {?} elementRef
 * @param {?} renderer
 */
constructor(
private elementRef:ElementRef,
private renderer:Renderer2 ) {
  }
/**
 * @param {?} event
 * @return {?}
 */
onDragStart( event:DndEvent ) {

    if( this.draggable === false ) {

      return false;
    }

    // check if there is dnd handle and if the dnd handle was used to start the drag
    if( typeof this.dndHandle !== "undefined"
      && typeof event._dndUsingHandle === "undefined" ) {

      return false;
    }

    // initialize global state
    startDrag( event, this.dndEffectAllowed, this.dndType );

    setDragData( event, {data: this.dndDraggable, type: this.dndType}, dndState.effectAllowed );

    this.determineDragImage();

    // set dragging css class prior to setDragImage so styles are applied before
    // TODO breaking change: add class to elementRef rather than drag image which could be another element
    this.renderer.addClass( this.dragImage, this.dndDraggingClass );

    // set custom dragimage if present
    // set dragimage if drag is started from dndHandle
    if( typeof this.dndDragImageElementRef !== "undefined"
      || typeof event._dndUsingHandle !== "undefined" ) {

      setDragImage( event, this.dragImage, this.dndDragImageOffsetFunction );
    }

    // add dragging source css class on first drag event
    const /** @type {?} */ unregister = this.renderer.listen( this.elementRef.nativeElement, "drag", () => {

      this.renderer.addClass( this.elementRef.nativeElement, this.dndDraggingSourceClass );
      unregister();
    } );

    this.dndStart.emit( event );

    event.stopPropagation();
  }
/**
 * @param {?} event
 * @return {?}
 */
onDragEnd( event:DragEvent ) {

    // get drop effect from custom stored state as its not reliable across browsers
    const /** @type {?} */ dropEffect = dndState.dropEffect;

    let /** @type {?} */ dropEffectEmitter:EventEmitter<DragEvent>;

    switch( dropEffect ) {

      case "copy":
        dropEffectEmitter = this.dndCopied;
        break;

      case "link":
        dropEffectEmitter = this.dndLinked;
        break;

      case "move":
        dropEffectEmitter = this.dndMoved;
        break;

      default:
        dropEffectEmitter = this.dndCanceled;
        break;
    }

    dropEffectEmitter.emit( event );
    this.dndEnd.emit( event );

    // reset global state
    endDrag();

    this.renderer.removeClass( this.dragImage, this.dndDraggingClass );

    // IE9 special hammering
    window.setTimeout( () => {
      this.renderer.removeClass( this.elementRef.nativeElement, this.dndDraggingSourceClass );
    }, 0 );

    event.stopPropagation();
  }
/**
 * @param {?} handle
 * @return {?}
 */
registerDragHandle( handle:DndHandleDirective | undefined ) {

    this.dndHandle = handle;
  }
/**
 * @param {?} elementRef
 * @return {?}
 */
registerDragImage( elementRef:ElementRef | undefined ) {

    this.dndDragImageElementRef = elementRef;
  }
/**
 * @return {?}
 */
private determineDragImage() {

    // evaluate custom drag image existence
    if( typeof this.dndDragImageElementRef !== "undefined" ) {

      this.dragImage = /** @type {?} */(( this.dndDragImageElementRef.nativeElement as Element));
    }
    else {

      this.dragImage = this.elementRef.nativeElement;
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: "[dndDraggable]"
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: Renderer2, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'dndDraggable': [{ type: Input },],
'dndEffectAllowed': [{ type: Input },],
'dndType': [{ type: Input },],
'dndDraggingClass': [{ type: Input },],
'dndDraggingSourceClass': [{ type: Input },],
'dndDraggableDisabledClass': [{ type: Input },],
'dndDragImageOffsetFunction': [{ type: Input },],
'dndStart': [{ type: Output },],
'dndEnd': [{ type: Output },],
'dndMoved': [{ type: Output },],
'dndCopied': [{ type: Output },],
'dndLinked': [{ type: Output },],
'dndCanceled': [{ type: Output },],
'draggable': [{ type: HostBinding, args: ["attr.draggable", ] },],
'dndDisableIf': [{ type: Input },],
'onDragStart': [{ type: HostListener, args: ["dragstart", [ "$event" ], ] },],
'onDragEnd': [{ type: HostListener, args: ["dragend", [ "$event" ], ] },],
};
}

function DndDraggableDirective_tsickle_Closure_declarations() {
/** @type {?} */
DndDraggableDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DndDraggableDirective.ctorParameters;
/** @type {?} */
DndDraggableDirective.propDecorators;
/** @type {?} */
DndDraggableDirective.prototype.dndDraggable;
/** @type {?} */
DndDraggableDirective.prototype.dndEffectAllowed;
/** @type {?} */
DndDraggableDirective.prototype.dndType;
/** @type {?} */
DndDraggableDirective.prototype.dndDraggingClass;
/** @type {?} */
DndDraggableDirective.prototype.dndDraggingSourceClass;
/** @type {?} */
DndDraggableDirective.prototype.dndDraggableDisabledClass;
/** @type {?} */
DndDraggableDirective.prototype.dndDragImageOffsetFunction;
/** @type {?} */
DndDraggableDirective.prototype.dndStart;
/** @type {?} */
DndDraggableDirective.prototype.dndEnd;
/** @type {?} */
DndDraggableDirective.prototype.dndMoved;
/** @type {?} */
DndDraggableDirective.prototype.dndCopied;
/** @type {?} */
DndDraggableDirective.prototype.dndLinked;
/** @type {?} */
DndDraggableDirective.prototype.dndCanceled;
/** @type {?} */
DndDraggableDirective.prototype.draggable;
/** @type {?} */
DndDraggableDirective.prototype.dndHandle;
/** @type {?} */
DndDraggableDirective.prototype.dndDragImageElementRef;
/** @type {?} */
DndDraggableDirective.prototype.dragImage;
/** @type {?} */
DndDraggableDirective.prototype.elementRef;
/** @type {?} */
DndDraggableDirective.prototype.renderer;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
